import { useCallback } from 'react';

const useScrollToTop = () => {
    const scrollToTop = useCallback(() => {
        // Add a small delay to ensure navigation is complete
        setTimeout(() => {
            try {
                // Method 1: Standard scrollTo
                window.scrollTo(0, 0);
                
                // Method 2: Smooth scroll to top (fallback)
                setTimeout(() => {
                    window.scrollTo({
                        top: 0,
                        left: 0,
                        behavior: 'smooth'
                    });
                }, 50);
                
                // Method 3: For older browsers
                if (document.documentElement) {
                    document.documentElement.scrollTop = 0;
                }
                if (document.body) {
                    document.body.scrollTop = 0;
                }
            } catch (error) {
                console.log('Scroll to top error:', error);
            }
        }, 100);
    }, []);

    return scrollToTop;
};

export default useScrollToTop;
